import React, { useState, useEffect } from "react";
import { Row, Col, Switch, Spin } from "antd";
import PricingItem from "./item";
import { getAllPlans } from "@api/subscription/plan";
import { useSelector } from "react-redux";

const OnboardSubscribe = () => {
  const { currentSubscription } = useSelector((state) => state.admin);
  const [plans, setPlans] = useState([]);
  const [annualCycle, setAnnualCycle] = useState(true);
  const [loading, setLoading] = useState(false);

  const billedText = `Billed ${annualCycle ? "annually" : "monthly"}`;

  // Get all plans
  useEffect(() => {
    setLoading(true);
    getAllPlans()
      .then((res) => {
        // API returns { plans: [...], pagination: {...} }
        setPlans(res.data.plans || res.data || []);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  }, []);

  // Toggle billing cycle
  const onChange = (checked) => {
    if (checked) {
      setAnnualCycle(true);
    } else {
      setAnnualCycle(false);
    }
  };

  return (
    <Row gutter={[32, 32]} className="hp-mb-32">
      <Col span={24}>
        <Row>
          {/* Header  */}
          <Col span={24}>
            <Row align="middle" justify="center" className="hp-mb-12">
              <h2 className="subscribe-heading">
                Professional, entrepreneur, or a student? We've got you covered
              </h2>
            </Row>
          </Col>

          {/* Plans */}
          {loading ? (
            <Row
              align="middle"
              justify="center"
              style={{
                height: "60vh",
                marginLeft: "50%",
              }}
            >
              <Spin />
            </Row>
          ) : (
            <Col span={24}>
              <Row align="middle" justify="center" className="hp-mt-8 hp-mb-8">
                {/* Billed Monthly */}
                <span
                  className={`hp-caption ${
                    annualCycle
                      ? "hp-text-color-black-60"
                      : "hp-text-color-primary-1"
                  }`}
                  style={{
                    fontWeight: "bold",
                    fontSize: "16px",
                    marginRight: "8px",
                  }}
                >
                  Billed monthly
                </span>

                {/* Switch */}
                <Switch
                  className="hp-mx-8"
                  defaultChecked
                  onChange={onChange}
                />

                {/* Billed Annually */}
                <span
                  className={`hp-caption ${
                    annualCycle
                      ? "hp-text-color-primary-1"
                      : "hp-text-color-black-60"
                  }`}
                  style={{
                    fontWeight: "bold",
                    fontSize: "16px",
                    marginLeft: "8px",
                  }}
                >
                  Billed Annually
                </span>
              </Row>

              <Row align="middle" justify="center" className="hp-mt-32 hp-mb-8">
                <h3
                  style={{
                    fontSize: "28px",
                    fontWeight: "bold",
                    background:
                      "linear-gradient(90deg, #FF0000 0%, #FF7F00 17.5%, #0000FF 70%, #4B0082 87.5%, #8F00FF 100%)",
                    color: "transparent",
                    WebkitBackgroundClip: "text", // for Safari
                    backgroundClip: "text",
                  }}
                >
                  Save 2 MONTHS on annual plan
                </h3>
              </Row>

              {/* Pricing Item Component */}
              <PricingItem
                plans={plans}
                annualCycle={annualCycle}
                billedText={billedText}
                currentSubscription={currentSubscription}
              />
            </Col>
          )}
        </Row>
      </Col>
    </Row>
  );
};

export default OnboardSubscribe;
